import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { EmailLoginForm } from '@/components/EmailLoginForm'
import { SocialLoginGroup } from '@/components/social/SocialLoginGroup'
import { useAuthStore } from '@/store/authStore'

export function LoginPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const redirect = searchParams.get('redirect') || '/'
  const initialType = searchParams.get('type') as 'student' | 'parent' | null
  const [tab, setTab] = useState<'student' | 'parent'>(initialType || 'student')

  useEffect(() => {
    if (isAuthenticated) {
      navigate(decodeURIComponent(redirect), { replace: true })
    }
  }, [isAuthenticated, navigate, redirect])

  const handleSuccess = () => {
    navigate(decodeURIComponent(redirect), { replace: true })
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900">깨봉 로그인</h1>
          <p className="mt-1 text-sm text-gray-500">깨처를 시청하려면 로그인하세요</p>
        </div>

        {/* Tab */}
        <div className="flex rounded-lg bg-gray-100 p-1">
          <button
            onClick={() => setTab('student')}
            className={`flex-1 rounded-md py-2 text-sm font-medium transition-colors ${
              tab === 'student'
                ? 'bg-white text-gray-900 shadow-xs'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            학습자
          </button>
          <button
            onClick={() => setTab('parent')}
            className={`flex-1 rounded-md py-2 text-sm font-medium transition-colors ${
              tab === 'parent'
                ? 'bg-white text-gray-900 shadow-xs'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            학부모
          </button>
        </div>

        {/* Email/Password Form */}
        <EmailLoginForm userType={tab} onSuccess={handleSuccess} />

        {/* Social Login (parent only) */}
        {tab === 'parent' && (
          <SocialLoginGroup onSuccess={handleSuccess} />
        )}
      </div>
    </div>
  )
}
